import { Component, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AddressLookupService } from '../../services/ss-address-lookup.service';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { debounceTime, tap } from 'rxjs/operators';
import { fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-addressbox',
  templateUrl: './addressbox.component.html',
})
export class AddressboxComponent implements OnInit, OnDestroy {
  @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
  @ViewChild('trigger', { static: true }) autoCompleteTrigger: MatAutocompleteTrigger;

  @Input() fieldname = 'address-search';
  @Input() fieldvalue: string;
  @Input() readonly: boolean;
  @Input('filterbyzipcode') filteredByZipCode = '';

  @Output() suggestedaddress = new EventEmitter<any>();

  public form: FormGroup = new FormGroup({});
  public addressOptions = <any>[];

  errorMsg: string;
  minSearchInputLength: number = 3;
  throttleMs = 300;
  searchBox: FormControl;
  isLoading: boolean;

  private $searchValueChangeSubscription: Subscription;
  private $searchDebounceSubscription: Subscription;

  constructor(private _addressLookupService: AddressLookupService, private fb: FormBuilder) { }
  ngOnDestroy(): void {
    this.$searchValueChangeSubscription.unsubscribe();
    this.$searchDebounceSubscription.unsubscribe();
  }

  ngOnInit() {
    this.isLoading = false;
    this.searchBox = new FormControl();
    this.form = this.fb.group(
      { "searchBox": this.searchBox }
    );

    if (this.readonly) {
      this.form.disable();
    }

    this.$searchValueChangeSubscription = this.searchBox.valueChanges.subscribe((value) => this.emitAddressResponse({ streetLine: value }, false));

    this.$searchDebounceSubscription = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      debounceTime(this.throttleMs)
    ).subscribe(() => {
      this.searchForAddress();
    });

    this.form.markAllAsTouched();
  }

  async searchForAddress() {
    const term = this.searchBox.value;
    this.addressOptions = [];

    if (!term || term.length < this.minSearchInputLength) {
      return;
    }

    var addressResult = await this._addressLookupService.AutocompleteAddress(term, this.filteredByZipCode);

    this.addressOptions = addressResult?.result as any[];
    this.isLoading = true;
    this.autoCompleteTrigger.openPanel();
  }

  public async fetchSubAddress(addrObj) {
    if (addrObj.entries > 1) {

      this.addressOptions = [];

      var selectedSubAddress = `${addrObj.streetLine} ${addrObj.secondary} (${addrObj.entries}) ${addrObj.city} ${addrObj.state} ${addrObj.zipcode}`;

      var subAddressSearchResponse = await this._addressLookupService.AutocompleteAddress(addrObj.streetLine, this.filteredByZipCode, selectedSubAddress);

      this.addressOptions = subAddressSearchResponse?.result as any[];
      this.autoCompleteTrigger.openPanel();
    }
  }

  setAddress(addrObj) {
    this.fieldvalue = addrObj.streetLine;
    this.searchBox.setValue(addrObj.streetLine);
    this.emitAddressResponse(addrObj);
    this.addressOptions = [];
  }

  emitAddressResponse(addressObj, success: boolean = true) {
    this.suggestedaddress.emit({ ...addressObj, success: success });
    this.isLoading = false;
  }
}
